module.exports = __webpack_public_path__ + "img/re-order-active.24dd9fe1.svg";